/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { onboardingListInvites } from "../../funcs/onboardingListInvites.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListOnboardingInvitesRequest$inboundSchema,
};

export const tool$onboardingListInvites: ToolDefinition<typeof args> = {
  name: "onboarding-list-invites",
  description: `List all the onboarding invites created by the caller's account.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await onboardingListInvites(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
